import axios from "axios";
import { useEffect, useState, useRef } from "react";
import regionResultType from "../model/regionResultType";
import Result from "../components/RegionLogResult";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import ExcelJS from 'exceljs';
import "./RegionLog.css";

const RegionLog = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [deviceid, setDeviceId] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("");
    const [region_id, setRegion_Id] = useState<string>("");
    const [in_out, setIn_Out] = useState<string>("");
    const [detected_gt, setDetcted_gt] = useState<string>("");
    const [detected_lt, setDetcted_lt] = useState<string>("");
    const [arrived_gt, setArrived_gt] = useState<string>("");
    const [arrived_lt, setArrived_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<regionResultType[]>([]);
    const results: regionResultType[] = [];
    const [csvResult, setCSVResult] = useState<regionResultType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);   // CSV全件取得
    const [isFetching, setIsFetching] = useState<boolean>(false); // 検索・ページング
    const [isNoCheck, setNoCheck] = useState<boolean>(false);

    // ---- UI-only state ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    var apiUrl:string = "";

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/region_logs"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/region_logs"
      }
    }

    const getRegionLog = async(e: any, pageNo: number) => {
        e.preventDefault();
        if (per_page === "") {
          setPer_Page("100")
        }
        saveParams();
        saveApikey();
        checkLocoEnv();
        setIsFetching(true);
        try {
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(deviceid ? {device_id: [deviceid]} : {}),
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(region_id ? {region_id: region_id} : {}),
              ...(in_out ? {in_out: in_out} : {}),
              ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
              ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
              ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
              ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            if (pageNo === 0) {
              alert("10万件を超えるデータは表示出来ません\n10万件までのデータを表示します\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            }

            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(getLastPageNo())
            //return
          } else {
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(items.last_page)
          }

          items.data.forEach((value: regionResultType, index: number) => {
            results.push(value)
            results[index].no = items.from;
            items.from++;
          })
          setResult(results)
        })
        .catch(err =>
          alert("エラーが発生しました。" + err)
        )
        } finally {
          setIsFetching(false);
        }
    }

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {

      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("regionLog");
      const worksheet = workbook.getWorksheet("regionLog");
      const columns: Partial<ExcelJS.Column>[] = [];

      if (isNoCheck) {
        columns.push({ header: "no", key: "no" })
      }
      columns.push({ header: "id", key: "id" })
      columns.push({ header: "bundle_id", key: "bundle_id" })
      columns.push({ header: "device_id", key: "device_id" })
      columns.push({ header: "region_id", key: "region_id" })
      columns.push({ header: "in_out", key: "in_out" })
      columns.push({ header: "detected", key: "detected" })
      columns.push({ header: "arrived", key: "arrived" })

      worksheet.columns = columns;
      setIsLoading(true);
      if (await getAllRegionLog(e, 1) == true) {

        csvResult.forEach((value: regionResultType) => {
          worksheet.addRow(value);
        });

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "regionlog_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
          },1000)

        } catch (error) {
          console.error(error);
        }
      } else {
        setIsLoading(false);
      }

    }

    const getAllRegionLog = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();
      await axios.get(apiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
            ...(deviceid ? {device_id: [deviceid]} : {}),
            ...(pageNo ? {page: pageNo} : {}),
            ...({per_page: 1000}),
            ...(region_id ? {region_id: region_id} : {}),
            ...(in_out ? {in_out: in_out} : {}),
            ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
            ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
            ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
            ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
            ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          if (pageNo === 1) {
            let result = window.confirm("10万件を超えるデータは出力出来ません\n10万件までのデータを出力しますか？\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            if (result === false) {
              return ret = false
            }
          }

        } else {
          setLastPageNo(items.last_page)
        }
        let csvArrayCount = csvResult.length;

        items.data.forEach((value: regionResultType, index: number) => {
          csvResult.push(value);
          csvResult[index + csvArrayCount].no = items.from;
          items.from++;
        })
        setCSVResult(csvResult);

        if (items.last_page > 100) {
          if (items.current_page != 100) {
            await getAllRegionLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        } else {
          if (items.current_page != items.last_page) {
            await getAllRegionLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )
      return ret
  }

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_gt(value);
  }
  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_lt(value);
  }
  const changeArrivedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_gt(value);
  }
  const changeArrivedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_lt(value);
  }
  const changePerPage = (value: string) => { setPer_Page(value) }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  const getLastPageNo = () => {
    if (per_page === "") { return 100000 / 100 }
    else { return 100000 / Number(per_page) }
  }

  type regionParamsType = {
    apikey?: string, deviceid?: string, perpage?: string, regionid?: string, inout?: string,
    detectedgt?: string, detectedlt?: string, arrivedgt?: string, arrivedlt?: string, sort?: string
  }

  const saveParams = () => {
    let params: regionParamsType = {};
    params.deviceid = deviceid ? deviceid : "";
    params.perpage = per_page ? per_page : "";
    params.regionid = region_id ? region_id : "";
    params.inout = in_out ? in_out : "";
    params.detectedgt = detected_gt ? detected_gt : "";
    params.detectedlt = detected_lt ? detected_lt : "";
    params.arrivedgt = arrived_gt ? arrived_gt : "";
    params.arrivedlt = arrived_lt ? arrived_lt : "";
    params.sort = sort ? sort : "";

    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoRegionParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoRegionParams")
    if (paramsJson != null) {
      const params:regionParamsType = JSON.parse(paramsJson as string)
      setDeviceId(params.deviceid ? params.deviceid : "");
      setPer_Page(params.perpage ? params.perpage : "")
      setRegion_Id(params.regionid ? params.regionid : "");
      setIn_Out(params.inout ? params.inout : "");
      setDetcted_gt(params.detectedgt ? params.detectedgt : "");
      setDetcted_lt(params.detectedlt ? params.detectedlt : "");
      setArrived_gt(params.arrivedgt ? params.arrivedgt : "");
      setArrived_lt(params.arrivedlt ? params.arrivedlt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) { setApikey(locoApikey ? locoApikey : ""); }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)
      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)
      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })
    }
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    deviceid ? { key: "device", label: "Device", value: deviceid, clear: () => setDeviceId("") } : null,
    region_id ? { key: "region", label: "Region", value: region_id, clear: () => setRegion_Id("") } : null,
    in_out ? { key: "io", label: "In_Out", value: in_out === "true" ? "RegionIn" : "RegionOut", clear: () => setIn_Out("") } : null,
    detected_gt ? { key: "dgt", label: "Detected ≥", value: detected_gt, clear: () => setDetcted_gt("") } : null,
    detected_lt ? { key: "dlt", label: "Detected ≤", value: detected_lt, clear: () => setDetcted_lt("") } : null,
    arrived_gt ? { key: "agt", label: "Arrived ≥", value: arrived_gt, clear: () => setArrived_gt("") } : null,
    arrived_lt ? { key: "alt", label: "Arrived ≤", value: arrived_lt, clear: () => setArrived_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page && per_page !== "100") ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("100") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setDeviceId(""); setRegion_Id(""); setIn_Out("");
    setDetcted_gt(""); setDetcted_lt(""); setArrived_gt(""); setArrived_lt("");
    setSort(""); setPer_Page("100");
  };

  return (
    <div className="bl-page">
      <Header current_page="Region"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title"><Ico name="filter"/> 検索条件</span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="rl-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getRegionLog(e, 0)}>
            <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
              {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
            </button>

            <div>
              <div className="bl-group-label">接続先</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">ApiKey</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => setApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Per_Page</span>
                    <span className="bl-field-hint">既定100 / 最大1000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => changePerPage(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">識別子</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">Device_Id</label>
                  <input className="bl-input bl-mono" type="text" name="deviceId" value={deviceid}
                    placeholder="Device_Idを入力" onChange={(e) => setDeviceId(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">Region_Id</label>
                  <input className="bl-input bl-mono" type="text" name="region_id" value={region_id}
                    placeholder="Region_Idを入力" onChange={(e) => setRegion_Id(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">In_Out</label>
                  <select className="bl-select" value={in_out} onChange={e => setIn_Out(e.target.value)}>
                    <option value="">RegionIn / RegionOut を指定</option>
                    <option value="true">True（RegionIn）</option>
                    <option value="false">False（RegionOut）</option>
                  </select>
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Detected（リージョンイベント発生時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降 (gt)</label>
                  <input className="bl-input" type="datetime-local" step="1" autoComplete="on" name="detected_gt"
                    value={detected_gt} onChange={(e) => changeDetectedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前 (lt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="detected_lt"
                    value={detected_lt} onChange={(e) => changeDetectedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Arrived（サーバー到達時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降 (gt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_gt"
                    value={arrived_gt} onChange={(e) => changeArrivedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前 (lt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_lt"
                    value={arrived_lt} onChange={(e) => changeArrivedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <div className="bl-aside-actions">
              <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
                {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
              </button>
              <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
            </div>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>RegionLog</h2>
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isFetching || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isFetching || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.length === 0 && <span className="bl-chips-empty">条件は未設定です</span>}
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(total > 0 && result.length > 0) ? (
              <>
                <Result result={result} />
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getRegionLog} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するログがありません" : "RegionLogを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isFetching || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "読み込み中…"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default RegionLog